import { ChangeDetectorRef, Component, computed, signal, effect, WritableSignal, ViewChild, Signal, ViewChildren, QueryList, ElementRef, HostListener, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { MessageService, MenuItem } from 'primeng/api';
import { AppMainComponent, CloseEvent } from 'src/app/app.main.component';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { RapportSST } from 'src/app/entites/rapport-sst';
import { RapportSstService } from 'src/app/services/rapport-sst-service';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { ETypeLien } from 'src/app/entites/enums/type-lien-document';
import { EModeAffichage } from 'src/app/base/mode-affichage';
import { LigneRapportSst } from 'src/app/entites/ligne-rapport-sst';
import { TempsRapportSST } from 'src/app/entites/temps-rapport-sst';
import { v4 as uuidv4 } from 'uuid';
import { RapportService } from 'src/app/services/rapport-service';
import { environment } from 'src/environments/environment';
import { peutUtiliserWebShare } from 'src/app/services/web-share';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { DialogService } from 'primeng/dynamicdialog';
import { SelectionDestinatairesRapportSSTComponent } from 'src/app/controles/selection-destinataires-rapport-sst.component';
import { Menu } from 'primeng/menu';
import { ThemeService } from 'src/app/services/theme.service';
import { ComponentCanDeactivate } from 'src/app/services/pending-changes.guard';
import { SaveAndQuitService, ComponentWithSaveAndQuit } from 'src/app/services/save-and-quit.service';
import { Subject, Observable, lastValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { Map as MapboxMap, Marker } from 'mapbox-gl';

@Component({
  selector: 'app-detail-rapport-journalier-sst',
  templateUrl: './detail-rapport-journalier-sst.component.html',
  styles: [`
    :host ::ng-deep p-inputnumber > span > input {
      width: 40px;
    }
    :host ::ng-deep .ql-toolbar {
      border-top-left-radius: 0.5rem;
      border-top-right-radius: 0.5rem;
    }
    :host ::ng-deep .ql-container {
      border-bottom-left-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }

    :host ::ng-deep .p-tag-success {
      background-color: #4caf50;
      color: #ffffff;
    }

    :host ::ng-deep .p-tag-info {
      background-color: #ffeb3b;
      color: #ffffff;
    }

    :host ::ng-deep .p-tag-warning {
      background-color: #ff9800;
      color: #ffffff;
    }

    :host ::ng-deep .p-tag-danger {
      background-color: #f44336;
      color: #ffffff;
    }

    /* Timeline Styles */
    .timeline-container {
      position: relative;
      padding-left: 2rem;
    }

    .timeline-item {
      position: relative;
      margin-bottom: 1.5rem;
      padding-left: 1rem;
    }

    .timeline-item:not(:last-child)::before {
      content: '';
      position: absolute;
      left: -1.5rem;
      top: 2.5rem;
      bottom: -1.5rem;
      width: 2px;
      background: #e5e7eb;
    }

    .timeline-marker {
      position: absolute;
      left: -2rem;
      top: 0.5rem;
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 0.75rem;
      z-index: 1;
    }

    .timeline-marker.bureau {
      background: #3b82f6;
    }

    .timeline-marker.chantier {
      background: #f97316;
    }

    .timeline-marker.pause {
      background: #10b981;
    }

    .timeline-content {
      background: #f9fafb;
      border-radius: 0.5rem;
      padding: 1rem;
      border-left: 4px solid #e5e7eb;
    }

    .timeline-content.break-content {
      background: #f0fdf4;
      border-left: 4px solid #10b981;
      opacity: 0.8;
    }

    .timeline-content .timeline-header {
      margin-bottom: 0.5rem;
    }

    .timeline-content .timeline-body {
      padding-top: 0.5rem;
      border-top: 1px solid #e5e7eb;
    }

    /* Calendar time picker adjustments */
    :host ::ng-deep .p-calendar-timeonly .p-inputtext {
      text-align: center;
    }

    /* Card height consistency */
    :host ::ng-deep .p-card.h-full {
      height: 100%;
    }

    /* Header map styles */
    .header-map {
      min-width: 6rem;
      min-height: 6rem;
      background-color: var(--surface-100);
    }

    /* Custom marker styles */
    :host ::ng-deep .custom-marker {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      background: #00843D;
      border-radius: 50% 50% 50% 0;
      transform: rotate(-45deg);
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    }

    :host ::ng-deep #bon-coup > .p-tag-info {
      background-color: #3b82f6;
      color: white;
    }

    :host ::ng-deep .custom-marker i {
      transform: rotate(45deg);
      color: white;
      font-size: 14px;
    }

    :host ::ng-deep #prevision-meteo > .p-card > .p-card-body {
      padding-top: 0;
      padding-bottom: 0;
    }

    /* State-based row styling */
    :host ::ng-deep .ligne-bon-coup {
      background-color: rgba(59, 130, 246, 0.08) !important;
    }

    :host ::ng-deep .ligne-bon-coup:hover {
      background-color: rgba(59, 130, 246, 0.15) !important;
    }

    :host ::ng-deep .ligne-observation {
      background-color: rgba(251, 146, 60, 0.08) !important;
    }

    :host ::ng-deep .ligne-observation:hover {
      background-color: rgba(251, 146, 60, 0.15) !important;
    }

    :host ::ng-deep .ligne-non-conformite {
      background-color: rgba(239, 68, 68, 0.08) !important;
    }

    :host ::ng-deep .ligne-non-conformite:hover {
      background-color: rgba(239, 68, 68, 0.15) !important;
    }

    /* Dark mode adjustments for row colors */
    :host-context(.dark) ::ng-deep .ligne-bon-coup {
      background-color: rgba(59, 130, 246, 0.15) !important;
    }

    :host-context(.dark) ::ng-deep .ligne-bon-coup:hover {
      background-color: rgba(59, 130, 246, 0.25) !important;
    }

    :host-context(.dark) ::ng-deep .ligne-observation {
      background-color: rgba(251, 146, 60, 0.15) !important;
    }

    :host-context(.dark) ::ng-deep .ligne-observation:hover {
      background-color: rgba(251, 146, 60, 0.25) !important;
    }

    :host-context(.dark) ::ng-deep .ligne-non-conformite {
      background-color: rgba(239, 68, 68, 0.15) !important;
    }

    :host-context(.dark) ::ng-deep .ligne-non-conformite:hover {
      background-color: rgba(239, 68, 68, 0.25) !important;
    }

    /* State badge styling */
    .state-badge {
      font-size: 1.2rem;
      padding: 0.25rem;
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 2rem;
      height: 2rem;
    }

    .state-badge-boncoup {
      color: #3b82f6;
      background-color: rgba(59, 130, 246, 0.1);
    }

    .state-badge-observation {
      color: #fb923c;
      background-color: rgba(251, 146, 60, 0.1);
    }

    .state-badge-nonconformite {
      color: #ef4444;
      background-color: rgba(239, 68, 68, 0.1);
    }

    /* State toggle button styling */
    :host ::ng-deep .state-toggle .p-button {
      padding: 0.5rem 1rem;
      font-size: 0.875rem;
    }

    :host ::ng-deep .state-toggle .p-button i {
      font-size: 1rem;
    }

    /* Mobile-friendly toggle buttons */
    @media (max-width: 768px) {
      :host ::ng-deep .state-toggle {
        flex-direction: column;
        width: 100%;
      }

      :host ::ng-deep .state-toggle .p-button {
        width: 100%;
        justify-content: center;
      }

      .state-toggle-cell {
        padding: 1rem !important;
      }
    }

    /* State toggle cell */
    :host ::ng-deep .state-toggle-cell {
      padding: 0.75rem;
      vertical-align: middle;
    }
  `],
  providers: [DialogService]
})
export class DetailRapportJournalierSstComponent extends BaseComponent implements ComponentCanDeactivate, ComponentWithSaveAndQuit, OnDestroy {

  rapportSST: RapportSST;

  // Header map properties
  headerMap: MapboxMap | null = null;
  headerMarker: Marker | null = null;
  @ViewChild('headerMapContainer') headerMapContainer: ElementRef;
  rapportSSTOriginal: RapportSST;
  lignesSignal = signal<LigneRapportSst[]>([]);
  tempsSignal = signal<TempsRapportSST[]>([]);
  lignesFiltrees = computed(() => this.lignesSignal().filter(ligne => !ligne.isDeleted));
  tempsFiltres = computed(() => this.tempsSignal().filter(temps => !temps.isDeleted));
  nbLignesSupprimees = computed(() => this.lignesSignal().filter(ligne => ligne.isDeleted).length);
  lastLineDirty = computed(() => {
    const lines = this.lignesSignal();
    if (lines.length === 0) return false;
    return lines[lines.length - 1].dirty();
  });

  // Time tracking properties
  nouveauTemps: TempsRapportSST = {
    rapportSstId: 0,
    type: 'Bureau',
    debut: null,
    fin: null,
    duree: '',
    commentaire: '',
    ordre: 0,
    isDeleted: false
  };

  menu: WritableSignal<MenuItem[]> = signal<MenuItem[]>([]);
  tabIndex: WritableSignal<number> = this.createParamSignal('tab', 0);
  suggestionCompagnie: string[] = [];
  showRiskMatrixDialog: boolean = false;
  menuLigne: MenuItem[];
  selectedLigne: WritableSignal<LigneRapportSst> = signal<LigneRapportSst>(null);

  // SST Mechanism inputs for asterisk items
  mecanismeSstInputs = signal<{ name: string; description: string; propertyName: string }[]>([]);

  // Mapping of property names to display names for asterisk mechanisms
  readonly mecanismeSstMapping: { propertyName: string; displayName: string }[] = [
    { propertyName: 'indVisiteConjointeSst', displayName: 'Visite conjointe SST' },
    { propertyName: 'indFormation', displayName: 'Formation' },
    { propertyName: 'indVisiteCnesst', displayName: 'Visite CNESST' },
    { propertyName: 'indInfoSst', displayName: 'Info-SST' },
    { propertyName: 'indInspMensuel', displayName: 'Insp. Mensuel' },
    { propertyName: 'indDiffusionMethode', displayName: 'Diffusion de méthode' },
    { propertyName: 'indPointArret', displayName: 'Point d\'arrêt' },
    { propertyName: 'indAutre', displayName: 'Autre' }
  ];

  @ViewChild('menuLigneRef') menuLigneRef: Menu;
  @ViewChildren('probabiliteInput') probabiliteInputs: QueryList<ElementRef>;

  constructor(
    sdb: DonneesBaseService,
    profilService: ProfilService,
    route: ActivatedRoute,
    public router: Router,
    public messageService: MessageService,
    public appMain: AppMainComponent,
    public rapportSstService: RapportSstService,
    private breadcrumbService: BreadcrumbService,
    private cdr: ChangeDetectorRef,
    private rapportService: RapportService,
    private dialogService: DialogService,
    protected themeService: ThemeService,
    private saveAndQuitService: SaveAndQuitService
  ) {
    super(sdb, profilService, route, router, appMain);
    this.breadcrumbService.setItems([
      { label: 'Rapport SST', routerLink: '/assurancequalite/rapportjournalier' },
      { label: 'Détails' }
    ]);

    effect(() => {
      if (this.lastLineDirty() && this.modeModification()) {
        setTimeout(() => {
          this.ajouterNouvelleLigne();
          this.cdr.detectChanges();
        });
      }
      this.lignesSignal().forEach(ligne => {
        ligne.indNonConformite = ligne.probabilite * ligne.gravite > environment.rapportSst.niveauNonConformite;
      });
    });

    effect(() => {
      this.menuLigne = [
        {
          label: 'Corriger',
          icon: 'pi pi-check',
          visible: this.checkLigneNonConformite(this.selectedLigne()),
          command: () => this.selectedLigne().indCorrige = !this.selectedLigne().indCorrige
        },
        {
          label: 'Supprimer',
          icon: 'pi pi-trash',
          disabled: this.selectedLigne() === null || !this.selectedLigne().dirty(),
          command: () => this.supprimerLigne(this.selectedLigne())
        }
      ];
    });

    this.loadRapportSST();

    this.onModeChange.subscribe((mode) => {
      if (mode == EModeAffichage.Modification) {
        this.ajouterNouvelleLigne();
        this.parseMecanismeSstFromCommentaire();
      }
    });
  }

  ngOnDestroy() {
    if (this.headerMap) {
      this.headerMap.remove();
    }
  }

  /// <summary>
  /// Initializes the header mini-map with the emplacement location
  /// </summary>
  private initHeaderMap() {
    if (!this.headerMapContainer || !this.rapportSST?.emplacement?.adresse) {
      return;
    }

    const defaultCenter: [number, number] = [-71.2080, 46.8139]; // Quebec City default

    this.headerMap = new MapboxMap({
      container: this.headerMapContainer.nativeElement,
      style: 'mapbox://styles/adminhc/cm6p7rhpi001v01qogqiq9wbj',
      zoom: 6,
      center: defaultCenter,
      pitch: 35,
      bearing: 0,
      accessToken: environment.mapbox.accessToken,
      interactive: false // Non-interactive for header display
    });

    // Update marker position after a short delay
    setTimeout(() => this.updateHeaderMapMarker(), 500);
  }

  /// <summary>
  /// Updates the header map marker based on emplacement address using geocoding
  /// </summary>
  private updateHeaderMapMarker() {
    if (!this.rapportSST?.emplacement?.adresse || !this.headerMap) {
      return;
    }

    const addr = this.rapportSST.emplacement.adresse;
    const address = `${addr.numero || ''} ${addr.rue || ''}, ${addr.municipalite || ''}, ${addr.province || ''}, ${addr.codePostal || ''}`.trim();

    fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${environment.mapbox.accessToken}`)
      .then(response => response.json())
      .then(data => {
        if (data.features && data.features.length > 0) {
          const coordinates = data.features[0].center;
          this.headerMap!.setCenter(coordinates);

          if (this.headerMarker) {
            this.headerMarker.remove();
          }

          // Create custom marker element
          const markerElement = document.createElement('div');
          markerElement.className = 'custom-marker';
          markerElement.innerHTML = '<i class="pi pi-map-marker"></i>';

          this.headerMarker = new Marker({
            element: markerElement
          }).setLngLat(coordinates);

          this.headerMarker.addTo(this.headerMap!);
        }
      });
  }

  loadRapportSST() {
    this.rapportSstService.ObtenirRapportSst(this.route.snapshot.params['id']).subscribe({
      next: (rapportSST) => {
        this.rapportSSTOriginal = rapportSST;
        this.initialiserRapportSST();

        this.menu.set([
          {
            label: 'Imprimer', icon: 'pi pi-fw pi-print', command: () => this.imprimer(),
            disabled: !this.modeConsultation()
          },
          {
            label: 'Partager', icon: 'pi pi-fw pi-share-alt',
            visible: peutUtiliserWebShare(),
            disabled: !this.modeConsultation(),
            items: [
              {
                label: 'Lien', icon: 'pi pi-fw pi-link', command: () => this.partager()
              },
              {
                label: 'PDF', icon: 'pi pi-fw pi-file-pdf', command: () => this.partagerPdf()
              }
            ]
          },
          {
            label: 'Actions', icon: 'pi pi-fw pi-bars',
            disabled: !this.modeConsultation(),
            items: [
              {
                label: 'Terminer et envoyer', icon: 'pi pi-fw pi-check', command: () => this.terminerEtEnvoyer(),
                disabled: this.rapportSST.statut.statutId == EStatuts.Envoye
              }
            ]
          }
        ]);

        this.CompleterChargement();

        // Initialize header map after DOM is ready
        setTimeout(() => this.initHeaderMap(), 100);
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: error.error });
      }
    });
  }

  private initializeLigneRapportSst(ligne: LigneRapportSst) {
    ligne.guid = uuidv4();
    ligne.total = signal((ligne.probabilite || 0) * (ligne.gravite || 0));
    ligne.severite = computed(() => ligne.total() == 0 ? 'info' : ligne.total() > 14 ? 'danger' : ligne.total() > 7 ? 'warning' : ligne.total() > 3 ? 'info' : 'success');
    ligne.severiteLabel = computed(() => ligne.total() == 0 ? 'Bon coup' : ligne.total() > 14 ? 'Extrême' : ligne.total() > 7 ? 'Élevé' : ligne.total() > 3 ? 'Moyen' : 'Faible');
    ligne.dirty = signal(true);
  }

  private ajouterNouvelleLigne() {
    const newLigne: LigneRapportSst = {
      ligneRapportSstId: 0,
      entreprise: '',
      lieu: '',
      description: '',
      probabilite: null,
      gravite: null,
      risqueDanger: '',
      indNonConformite: false,
      indCorrige: false,
      indBonCoup: false,
      isDeleted: false
    };

    this.initializeLigneRapportSst(newLigne);
    newLigne.dirty.set(false);
    this.rapportSST.ligneRapportSst.push(newLigne);
    this.lignesSignal.set([...this.rapportSST.ligneRapportSst]);
  }

  rechercherCompagnie(event: any) {
    this.suggestionCompagnie = this.sdb.Compagnies().filter(x => x.nom.toLowerCase().includes(event.query.toLowerCase())).map(x => x.nom);
  }

  supprimerLigne(ligne: LigneRapportSst) {
    ligne.isDeleted = true;
    this.lignesSignal.set([...this.rapportSST.ligneRapportSst]);
  }

  /// <summary>
  /// Gets the current state of a line based on indBonCoup and risk score.
  /// </summary>
  getLineState(ligne: LigneRapportSst): 'boncoup' | 'observation' | 'nonconformite' {
    if (ligne.indBonCoup) {
      return 'boncoup';
    }
    const total = (ligne.probabilite || 0) * (ligne.gravite || 0);
    return total > environment.rapportSst.niveauNonConformite ? 'nonconformite' : 'observation';
  }

  /// <summary>
  /// Sets the state of a line and adjusts risk scores accordingly.
  /// </summary>
  setLineState(ligne: LigneRapportSst, state: 'boncoup' | 'observation' | 'nonconformite') {
    ligne.dirty.set(true);

    switch (state) {
      case 'boncoup':
        ligne.indBonCoup = true;
        // Clear risk scores for bon coup
        ligne.probabilite = null;
        ligne.gravite = null;
        ligne.total.set(0);
        break;

      case 'observation':
        ligne.indBonCoup = false;
        // Set minimal risk scores for observation (must be 0 for observation)
        ligne.probabilite = 0;
        ligne.gravite = 0;
        ligne.total.set(0);
        break;

      case 'nonconformite':
        ligne.indBonCoup = false;
        // Set default risk scores if not set
        if (!ligne.probabilite || ligne.probabilite === 0) {
          ligne.probabilite = 1;
        }
        if (!ligne.gravite || ligne.gravite === 0) {
          ligne.gravite = 1;
        }
        ligne.total.set((ligne.probabilite || 0) * (ligne.gravite || 0));
        break;
    }

    // Trigger change detection by updating the signal
    this.lignesSignal.set([...this.rapportSST.ligneRapportSst]);
  }

  get ETypeLienDocument(): typeof ETypeLien {
    return ETypeLien;
  }

  showRiskMatrix() {
    this.showRiskMatrixDialog = true;
  }

  // Required by ComponentCanDeactivate
  @HostListener('window:beforeunload')
  public async canDeactivate(): Promise<boolean> {
    // Use the service to check if confirmation should be skipped
    if (this.saveAndQuitService.shouldSkipConfirmation(this)) {
      return Promise.resolve(true);
    }

    // Create a new Subject for this confirmation instance
    this.appMain.onClosePromise = new Subject<CloseEvent>();

    // Show the confirmation dialog using appMain's ConfirmationService
    this.appMain.confirmationService.confirm({
      key: 'save-changes'
    });

    // Wait for user's decision and handle it using the service
    return await lastValueFrom(this.appMain.onClosePromise.pipe(
      map(async (event: CloseEvent) => {
        const result = await this.saveAndQuitService.handleCloseEvent(event, this, () => this.appMain.confirmChanges.hide());
        // Complete the subject after handling
        if (!this.appMain.onClosePromise.closed) {
          this.appMain.onClosePromise.complete();
        }
        return result;
      })
    ));
  }

  onSave(event: () => void) {
    this.enregistrerModifications.subscribe();
    event();
  }

  // Required by ComponentWithSaveAndQuit - wraps the existing save logic in an Observable
  enregistrerModifications: Observable<boolean> = new Observable<boolean>(observer => {
    // Remove the last empty line that's automatically added in edit mode

    // Merge mechanism SST inputs into commentaire before saving
    this.mergeMecanismeSstToCommentaire();

    this.Consulter();
    this.rapportSST.ligneRapportSst = this.rapportSST.ligneRapportSst.slice(0, -1);
    this.lignesSignal.update(lignes => lignes.slice(0, -1));

    this.rapportSstService.Modifier(this.rapportSST).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Rapport SST enregistré avec succès' });
        this.loadRapportSST();
        this.rapportSSTOriginal = { ...this.rapportSST, ligneRapportSst: [...this.rapportSST.ligneRapportSst.filter(ligne => !ligne.isDeleted)], tempsRapportSsts: [...this.rapportSST.tempsRapportSsts.filter(temps => !temps.isDeleted)] };
        this.initialiserRapportSST();
        observer.next(true);
        observer.complete();
      },
      error: (error) => {
        observer.next(false);
        observer.complete();
        this.Modifier();
      }
    });
  });

  enregistrerModificationsAutoSave() {
    var rapportSST = JSON.parse(JSON.stringify(this.rapportSST));
    rapportSST.ligneRapportSst.pop();

    this.rapportSstService.Modifier(rapportSST).subscribe({
      next: () => {
        this.loadRapportSST();
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Rapport SST enregistré avec succès' });
      }
    });
  }

  Annuler() {
    // Reset isDeleted flags when canceling
    this.rapportSST.ligneRapportSst.forEach(ligne => ligne.isDeleted = false);
    this.rapportSST.tempsRapportSsts.forEach(temps => temps.isDeleted = false);
    // Clear mechanism SST inputs
    this.mecanismeSstInputs.set([]);
    this.initialiserRapportSST();
    this.Consulter();
  }

  initialiserRapportSST() {
    // Create deep copies of the original data to avoid reference issues
    this.rapportSST = {
      ...this.rapportSSTOriginal,
      ligneRapportSst: this.rapportSSTOriginal.ligneRapportSst.map(ligne => ({ ...ligne, isDeleted: false })),
      tempsRapportSsts: this.rapportSSTOriginal.tempsRapportSsts ? this.rapportSSTOriginal.tempsRapportSsts.map(temps => ({ ...temps, isDeleted: false })) : []
    };

    this.lignesSignal.set([...this.rapportSST.ligneRapportSst]);

    // Only initialize the current lines, not the original lines
    this.rapportSST.ligneRapportSst.forEach(x => {
      this.initializeLigneRapportSst(x);
    });

    this.initialiserTemps();
  }

  imprimer() {
    this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Rapport en cours de génération...' });
    this.rapportService.ProduireRapportSST(this.rapportSST.rapportSstId).then(x => {
      if (x) {
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Rapport SST généré avec succès' });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la génération du rapport SST' });
      }
    });
  }

  async partager() {
    navigator.share({
      title: 'SIHC - Rapport journalier SST',
      text: `Rapport SST ${this.rapportSST.emplacement.nom} - ${this.rapportSST.date.toLocaleDateString()}`,
      url: environment.urlBase + '/assurancequalite/rapportjournalier/' + this.rapportSST.rapportSstId
    });
  }

  async partagerPdf() {
    var pdf = await this.rapportService.ObtenirPdfRapportSST(this.rapportSST.rapportSstId).catch(error => {
      this.messageService.add({ severity: 'error', summary: 'Erreur', detail: error.error });
      return null;
    });

    navigator.share({
      title: 'SIHC - Rapport journalier SST',
      text: `Rapport SST ${this.rapportSST.emplacement.nom} - ${this.rapportSST.date.toLocaleDateString()}`,
      files: [new File([pdf], 'rapport_sst.pdf', { type: 'application/pdf' })]
    });
  }

  terminerEtEnvoyer() {
    this.rapportSstService.ObtenirDestinatairesParDefaut(this.rapportSST.rapportSstId).subscribe({
      next: (destinatairesParDefaut) => {
        const ref = this.dialogService.open(SelectionDestinatairesRapportSSTComponent, {
          data: {
            destinatairesParDefaut,
            emplacementId: this.rapportSST.emplacementId
          },
          header: 'Sélection des destinataires',
          width: '60%'
        });

        ref.onClose.subscribe((destinataires: string[]) => {
          if (destinataires) {
            this.rapportSstService.EnvoyerEtFermerRapportSst(this.rapportSST.rapportSstId, destinataires).subscribe({
              next: _ => {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Rapport SST terminé et envoyé avec succès' });
                this.rapportSST.statut = {
                  statutId: EStatuts.Envoye,
                  nom: 'Envoyé'
                };
              },
              error: (error) => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: error.error });
              }
            });
          }
        });
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: error.error });
      }
    });
  }

  checkLigneNonConformite(ligne: LigneRapportSst) {
    console.log(ligne);
    return ligne && ligne.probabilite * ligne.gravite > environment.rapportSst.niveauNonConformite;
  }

  afficherMenuLigne(event: Event, ligne: LigneRapportSst) {
    this.selectedLigne.set(ligne);
    this.menuLigneRef.show(event);
  }

  getDateNonConformite(ligne: LigneRapportSst) {
    var date = ligne.dateNonConformite ? ligne.dateNonConformite.getDate() == this.rapportSST.date.getDate() ? 'ce rapport' : 'le ' + ligne.dateNonConformite.toLocaleDateString('fr-CA') : 'ce rapport';
    return date;
  }

  get EStatuts(): typeof EStatuts {
    return EStatuts;
  }

  get environment(): typeof environment {
    return environment;
  }

  get Math(): typeof Math {
    return Math;
  }

  transformerEnNonConformite(ligne: LigneRapportSst) {
    ligne.probabilite = 1;
    ligne.gravite = 1;
    ligne.total.set(1);

    // Focus on the probability field after a short delay to ensure the DOM is updated
    setTimeout(() => {
      const probabiliteInputs = this.probabiliteInputs.toArray();
      const ligneIndex = this.lignesSignal().findIndex(l => l.guid === ligne.guid);
      if (probabiliteInputs[ligneIndex]) {
        const inputElement = probabiliteInputs[ligneIndex].nativeElement.querySelector('input');
        if (inputElement) {
          inputElement.focus();
        }
      }
    }, 100);
  }

  // Time tracking methods
  initialiserTemps() {
    if (!this.rapportSST.tempsRapportSsts) {
      this.rapportSST.tempsRapportSsts = [];
    }

    // Add breaks to the existing time entries
    const tempsWithBreaks = this.ajouterPauses(this.rapportSST.tempsRapportSsts);

    this.tempsSignal.set(tempsWithBreaks.map(t => ({
      ...t,
      duree: this.formaterDuree(this.calculerDuree(t.debut, t.fin))
    })));
  }

  formaterDuree(minutes: number): string {
    const heures = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (heures > 0 && mins > 0) {
      return `${heures}h ${mins}m`;
    } else if (heures > 0) {
      return `${heures}h`;
    } else {
      return `${mins}m`;
    }
  }

  ajouterPauses(temps: TempsRapportSST[]): TempsRapportSST[] {
    console.log('ajouterPauses called with:', temps);
    // Filter out deleted items first
    const tempsActifs = temps.filter(t => !t.isDeleted);
    if (tempsActifs.length <= 1) {
      return tempsActifs;
    }

    // Sort by start time first
    const sortedTemps = [...tempsActifs].sort((a, b) => a.debut.getTime() - b.debut.getTime());
    console.log('Sorted temps:', sortedTemps);
    const result: TempsRapportSST[] = [];

    for (let i = 0; i < sortedTemps.length; i++) {
      result.push(sortedTemps[i]);

      // Check if there's a gap before the next period
      if (i < sortedTemps.length - 1) {
        const currentEnd = sortedTemps[i].fin;
        const nextStart = sortedTemps[i + 1].debut;

        console.log(`Checking gap between ${currentEnd.toLocaleTimeString()} and ${nextStart.toLocaleTimeString()}`);

        // Check if there's a gap (current end is before next start)
        if (currentEnd.getHours() * 60 + currentEnd.getMinutes() < nextStart.getHours() * 60 + nextStart.getMinutes()) {
          console.log('Gap detected, adding break');
          // There's a gap, add a break
          const pauseMinutes = this.calculerDuree(currentEnd, nextStart);
          const pause: TempsRapportSST = {
            tempsRapportSstId: 0,
            rapportSstId: sortedTemps[i].rapportSstId,
            type: 'Pause',
            debut: currentEnd,
            fin: nextStart,
            duree: this.formaterDuree(pauseMinutes),
            commentaire: 'Pause automatique',
            ordre: sortedTemps[i].ordre + 0.5, // Insert between current and next
            isBreak: true,
            isDeleted: false
          };
          result.push(pause);
        } else {
          console.log('No gap detected');
        }
      }
    }

    const finalResult = result.sort((a, b) => a.debut.getTime() - b.debut.getTime());
    console.log('Final result with breaks:', finalResult);
    return finalResult;
  }

  verifierChevauchement(nouveauTemps: TempsRapportSST): boolean {
    const tempsActifs = this.rapportSST.tempsRapportSsts.filter(t => !t.isDeleted);
    for (const temps of tempsActifs) {

      // Check if periods overlap
      if (nouveauTemps.debut.getTime() < temps.fin.getTime() &&
        nouveauTemps.fin.getTime() > temps.debut.getTime()) {
        return true; // Overlap detected
      }
    }

    return false; // No overlap
  }

  calculerDuree(heureDebut: string | Date, heureFin: string | Date): number {
    if (!heureDebut || !heureFin) return 0;

    let debutMinutes: number, finMinutes: number;

    if (heureDebut instanceof Date && heureFin instanceof Date) {
      // For Date objects, only use hours and minutes
      debutMinutes = heureDebut.getHours() * 60 + heureDebut.getMinutes();
      finMinutes = heureFin.getHours() * 60 + heureFin.getMinutes();
      return Math.max(0, finMinutes - debutMinutes);
    } else if (typeof heureDebut === 'string' && typeof heureFin === 'string') {
      // For string format (HH:mm)
      const [h1, m1] = heureDebut.split(':').map(Number);
      const [h2, m2] = heureFin.split(':').map(Number);
      debutMinutes = h1 * 60 + m1;
      finMinutes = h2 * 60 + m2;
      return Math.max(0, finMinutes - debutMinutes);
    } else {
      // Mixed types or invalid input
      return 0;
    }
  }

  formaterHeure(date: Date | string): string {
    if (!date) return '';

    if (date instanceof Date) {
      return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false });
    } else {
      return date;
    }
  }

  ajouterTemps() {
    if (!this.nouveauTemps.debut || !this.nouveauTemps.fin) {
      this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Veuillez saisir l\'heure de début et de fin' });
      return;
    }

    this.nouveauTemps.duree = this.formaterDuree(this.calculerDuree(this.nouveauTemps.debut, this.nouveauTemps.fin));

    if (this.calculerDuree(this.nouveauTemps.debut, this.nouveauTemps.fin) <= 0) {
      this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'L\'heure de fin doit être postérieure à l\'heure de début' });
      return;
    }

    // Check for overlapping periods
    if (this.verifierChevauchement(this.nouveauTemps)) {
      this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Cette période chevauche une période existante. Veuillez ajuster les heures.' });
      return;
    }

    this.nouveauTemps.rapportSstId = this.rapportSST.rapportSstId;
    this.nouveauTemps.ordre = this.rapportSST.tempsRapportSsts.length;

    // Add the new time entry first
    const tempsToSave: TempsRapportSST = {
      ...this.nouveauTemps,
      debut: this.nouveauTemps.debut,
      fin: this.nouveauTemps.fin
    };

    this.rapportSST.tempsRapportSsts.push(tempsToSave);

    // Now add breaks to the complete list (including the new entry)
    const tempsWithBreaks = this.ajouterPauses(this.rapportSST.tempsRapportSsts);

    this.tempsSignal.set(tempsWithBreaks.map(t => ({
      ...t,
      duree: this.formaterDuree(this.calculerDuree(t.debut, t.fin))
    })));

    // Reset form
    this.nouveauTemps = {
      rapportSstId: this.rapportSST.rapportSstId,
      type: 'Bureau',
      debut: null,
      fin: null,
      duree: '',
      commentaire: '',
      ordre: 0,
      isDeleted: false
    };
  }

  supprimerTemps(index: number) {
    const tempsFormatted = this.tempsSignal();
    const tempsToDelete = tempsFormatted[index];

    // Only allow deletion of non-break entries
    if (tempsToDelete.isBreak) {
      this.messageService.add({ severity: 'warn', summary: 'Information', detail: 'Les pauses automatiques ne peuvent pas être supprimées' });
      return;
    }

    // Find and mark the actual time entry as deleted (not the formatted one with breaks)
    const actualIndex = this.rapportSST.tempsRapportSsts.findIndex(t =>
      t.tempsRapportSstId === tempsToDelete.tempsRapportSstId
    );

    if (actualIndex !== -1) {
      this.rapportSST.tempsRapportSsts[actualIndex].isDeleted = true;

      // Recalculate breaks after marking as deleted
      const tempsWithBreaks = this.ajouterPauses(this.rapportSST.tempsRapportSsts.filter(t => !t.isDeleted));
      this.tempsSignal.set(tempsWithBreaks.map(t => ({
        ...t,
        duree: this.formaterDuree(this.calculerDuree(t.debut, t.fin))
      })));
    }
  }

  getTotalTemps(): string {
    const totalMinutes = this.rapportSST.tempsRapportSsts?.filter(t => !t.isDeleted).reduce((sum, t) => sum + this.calculerDuree(t.debut, t.fin), 0) || 0;
    return this.formaterDuree(totalMinutes);
  }

  getTotalTempsParType(type: 'Bureau' | 'Chantier'): string {
    const totalMinutes = this.rapportSST.tempsRapportSsts?.filter(t => t.type === type && !t.isDeleted).reduce((sum, t) => sum + this.calculerDuree(t.debut, t.fin), 0) || 0;
    return this.formaterDuree(totalMinutes);
  }

  defaultTime = computed(() => this.getTimeBasedOnStep(15));

  getTimeBasedOnStep(stepMinutes: number): Date {
    const now = new Date();
    const minutes = now.getMinutes();
    const roundedMinutes = Math.floor(minutes / stepMinutes) * stepMinutes;
    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), roundedMinutes);
  }

  getTotalPauses(): string {
    const tempsFormatted = this.tempsFiltres();
    const totalMinutes = tempsFormatted.filter(t => t.isBreak).reduce((sum, t) => sum + this.calculerDuree(t.debut, t.fin), 0);
    return this.formaterDuree(totalMinutes);
  }

  /**
   * Converts minutes to HH:MM format
   */
  minutesToHoursMinutes(minutes: number | null | undefined): string {
    if (!minutes || minutes === 0) return '';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
  }

  /**
   * Converts HH:MM format to minutes
   */
  hoursMinutesToMinutes(timeString: string): number {
    if (!timeString || timeString.trim() === '') return 0;
    const parts = timeString.split(':');
    if (parts.length !== 2) return parseInt(parts[0], 10) * 60;
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    if (isNaN(hours) || isNaN(minutes)) return 0;
    return hours * 60 + minutes;
  }

  /**
   * Updates minutesChantier from the formatted time input
   */
  updateMinutesChantier(event: Event) {
    const input = event.target as HTMLInputElement;
    this.rapportSST.minutesChantier = this.hoursMinutesToMinutes(input.value);
  }

  /**
   * Updates minutesBureau from the formatted time input
   */
  updateMinutesBureau(event: Event) {
    const input = event.target as HTMLInputElement;
    this.rapportSST.minutesBureau = this.hoursMinutesToMinutes(input.value);
  }

  /**
   * Formats minutes for display (HH:MM or just text)
   */
  formatMinutesForDisplay(minutes: number | null | undefined): string {
    if (!minutes || minutes === 0) return '';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours > 0 && mins > 0) {
      return `${hours}h ${mins}min`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else {
      return `${mins}min`;
    }
  }

  remettreAZeroNbJoursSansPerteDeTemps() {
    this.rapportSST.nbJoursSansPerteDeTemps = 0;
  }

  /// <summary>
  /// Handles the change event for SST mechanism checkboxes with asterisks.
  /// When checked, adds an input field. When unchecked, removes it.
  /// </summary>
  onMecanismeSstChange(event: any, mecanismeName: string, propertyName: string) {
    if (event.checked) {
      // Add a new input for this mechanism
      const existingInputs = this.mecanismeSstInputs();
      if (!existingInputs.find(i => i.propertyName === propertyName)) {
        this.mecanismeSstInputs.set([...existingInputs, { name: mecanismeName, description: '', propertyName }]);
      }
    } else {
      // Remove the input for this mechanism
      this.mecanismeSstInputs.update(inputs => inputs.filter(i => i.propertyName !== propertyName));
    }
  }

  /// <summary>
  /// Parses the commentaire field to extract existing mechanism entries when entering edit mode.
  /// Format expected: "<p>- <Name>: <description></p>"
  /// </summary>
  parseMecanismeSstFromCommentaire() {
    if (!this.rapportSST?.commentaire) {
      this.initMecanismeSstInputsFromCheckboxes();
      return;
    }

    const inputs: { name: string; description: string; propertyName: string }[] = [];
    let remainingCommentaire = this.rapportSST.commentaire;

    // Parse each mechanism from the commentaire
    for (const mapping of this.mecanismeSstMapping) {
      // Match <p>- <Name>: <description></p> with optional whitespace/newlines
      // Use non-greedy match to handle HTML content in descriptions
      const regex = new RegExp(`<p>\\s*-\\s*${this.escapeRegex(mapping.displayName)}:\\s*(.*?)</p>\\s*`, 'gi');
      const match = regex.exec(this.rapportSST.commentaire);

      if (match) {
        inputs.push({
          name: mapping.displayName,
          description: match[1]?.trim() || '',
          propertyName: mapping.propertyName
        });
        // Remove this entry from the commentaire
        remainingCommentaire = remainingCommentaire.replace(match[0], '');
      }
    }

    // Update the commentaire without the mechanism entries (they are now in inputs)
    this.rapportSST.commentaire = remainingCommentaire.trim();

    // Add inputs for checked mechanisms that weren't in the commentaire
    for (const mapping of this.mecanismeSstMapping) {
      const isChecked = (this.rapportSST as any)[mapping.propertyName];
      const existsInInputs = inputs.find(i => i.propertyName === mapping.propertyName);

      if (isChecked && !existsInInputs) {
        inputs.push({
          name: mapping.displayName,
          description: '',
          propertyName: mapping.propertyName
        });
      }
    }

    this.mecanismeSstInputs.set(inputs);
  }

  /// <summary>
  /// Initializes mechanism inputs based on currently checked checkboxes (without parsing commentaire).
  /// </summary>
  initMecanismeSstInputsFromCheckboxes() {
    const inputs: { name: string; description: string; propertyName: string }[] = [];

    for (const mapping of this.mecanismeSstMapping) {
      const isChecked = (this.rapportSST as any)[mapping.propertyName];
      if (isChecked) {
        inputs.push({
          name: mapping.displayName,
          description: '',
          propertyName: mapping.propertyName
        });
      }
    }

    this.mecanismeSstInputs.set(inputs);
  }

  /// <summary>
  /// Merges the mechanism SST inputs back into the commentaire field before saving.
  /// </summary>
  mergeMecanismeSstToCommentaire() {
    const inputs = this.mecanismeSstInputs();
    if (inputs.length === 0) return;

    let commentaire = this.rapportSST.commentaire || '';

    // Ensure there's a line break at the end if commentaire is not empty
    if (commentaire.length > 0 && !commentaire.endsWith('\n')) {
      commentaire += '\n';
    }

    // Append each mechanism entry wrapped in <p> tags
    for (const input of inputs) {
      commentaire += `<p>- ${input.name}: ${input.description}</p>\n`;
    }

    this.rapportSST.commentaire = commentaire;

    // Clear the inputs after merging
    this.mecanismeSstInputs.set([]);
  }

  /// <summary>
  /// Helper to escape special regex characters in a string.
  /// </summary>
  private escapeRegex(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  /// <summary>
  /// TrackBy function for mechanism SST inputs to prevent unnecessary DOM re-creation.
  /// </summary>
  trackByPropertyName(index: number, input: { name: string; description: string; propertyName: string }): string {
    return input.propertyName;
  }
}
